import { motion, type Transition } from 'framer-motion'
import { CircleSlash, Plus } from 'lucide-react'

const transition: Transition = {
  duration: 0.2,
  ease: 'easeInOut',
}

interface AnimatedEmptyIconProps {
  editable: boolean
  className?: string
}

export function AnimatedEmptyIcon({ editable, className }: AnimatedEmptyIconProps) {
  return (
    <div className={`relative ${className ?? ''}`}>
      <motion.div animate={{ opacity: editable ? 0 : 1 }} transition={transition} className="absolute inset-0">
        <CircleSlash className="size-full" />
      </motion.div>
      <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: editable ? 1 : 0 }}
        transition={transition}
        className="absolute inset-0"
      >
        <Plus className="size-full" />
      </motion.div>
    </div>
  )
}
